module.exports = __webpack_public_path__ + "img/no-image.4b1287b9.png";